import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableMenuLocationDetails',
  initialState: false,
  reducers: {
    setEnableMenuLocationDetails(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableMenuLocationDetails } = slice.actions;

export default slice.reducer;
